import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'webshop_company_video_file'

export const dataPointDefinition = {
  retracedId: 'webshop_company_video_file',
  name: 'Webshop Company Video File',
  meta: {},
  fieldTypeId: 'VIDEO_UPLOAD',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        anyOf: [
          {
            type: 'object',
            properties: {
              id: {
                type: 'string',
              },
              url: {
                type: 'string',
              },
            },
            required: ['id', 'url'],
          },
          {
            type: 'object',
            maxProperties: 0,
          },
        ],
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 37990,
  sectionId: '1.1',
  impactArea: 'About',
  impactAreaId: 'ABOUT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
